import { createBrowserRouter, Navigate } from 'react-router-dom';
import { CustomerPortalLayout } from '@/layouts/customer-portal/CustomerPortalLayout';
import { CustomerProtectedRoute } from '@/components/customer-portal/CustomerProtectedRoute';
import { CustomerLoginPage } from '@/features/customer-portal/auth/CustomerLoginPage';
import { CustomerActivationPage } from '@/features/customer-portal/auth/CustomerActivationPage';
import { CustomerDashboardPage } from '@/features/customer-portal/dashboard/CustomerDashboardPage';
import { CustomerEquipmentListPage } from '@/features/customer-portal/equipment/CustomerEquipmentListPage';
import { CustomerEquipmentDetailPage } from '@/features/customer-portal/equipment/CustomerEquipmentDetailPage';
import { CustomerJobListPage } from '@/features/customer-portal/jobs/CustomerJobListPage';
import { CustomerJobDetailPage } from '@/features/customer-portal/jobs/CustomerJobDetailPage';
import { CustomerRequestThreadPage } from '@/features/customer-portal/requests/CustomerRequestThreadPage';
import { CustomerDecisionQueuePage } from '@/features/customer-portal/decisions/CustomerDecisionQueuePage';
import { CustomerAppearancePage } from '@/features/customer-portal/appearance/CustomerAppearancePage';
import { CustomerAccountPage } from '@/features/customer-portal/account/CustomerAccountPage';
import { CustomerChangePasswordPage } from '@/features/customer-portal/account/CustomerChangePasswordPage';
import { CustomerPortalNotFoundPage } from '@/features/customer-portal/CustomerPortalNotFoundPage';
import { CUSTOMER_PORTAL_ROUTES } from './customer-portal-routes';

export const customerPortalRouter = createBrowserRouter([
  {
    path: CUSTOMER_PORTAL_ROUTES.LOGIN,
    element: <CustomerLoginPage />,
  },
  {
    // B6.14 — outside CustomerProtectedRoute by design: an invited customer has no
    // session yet, so gating activation behind one would lock out the only people
    // who need it.
    path: CUSTOMER_PORTAL_ROUTES.ACTIVATE,
    element: <CustomerActivationPage />,
  },
  {
    path: '/customer-portal',
    element: <CustomerPortalLayout />,
    children: [
      {
        element: <CustomerProtectedRoute />,
        children: [
          { index: true, element: <Navigate to={CUSTOMER_PORTAL_ROUTES.DASHBOARD} replace /> },
          { path: CUSTOMER_PORTAL_ROUTES.DASHBOARD, element: <CustomerDashboardPage /> },
          { path: CUSTOMER_PORTAL_ROUTES.EQUIPMENT, element: <CustomerEquipmentListPage /> },
          {
            path: CUSTOMER_PORTAL_ROUTES.EQUIPMENT_DETAIL,
            element: <CustomerEquipmentDetailPage />,
          },
          { path: CUSTOMER_PORTAL_ROUTES.JOBS, element: <CustomerJobListPage /> },
          { path: CUSTOMER_PORTAL_ROUTES.JOB_DETAIL, element: <CustomerJobDetailPage /> },
          // Stage D-i (D-145 / OD-D1) — inside CustomerProtectedRoute like every
          // other customer page. Gated on authentication alone: authorization is
          // the server's (OD-D11), and there is no customer PermissionRoute.
          { path: CUSTOMER_PORTAL_ROUTES.REQUEST_THREAD, element: <CustomerRequestThreadPage /> },
          { path: CUSTOMER_PORTAL_ROUTES.DECISIONS, element: <CustomerDecisionQueuePage /> },
          { path: CUSTOMER_PORTAL_ROUTES.APPEARANCE, element: <CustomerAppearancePage /> },
          // User Profile P2 — both inside the layout AND the guard: the guard exempts
          // CHANGE_PASSWORD from the forced-change redirect, so there is no loop.
          { path: CUSTOMER_PORTAL_ROUTES.ACCOUNT, element: <CustomerAccountPage /> },
          {
            path: CUSTOMER_PORTAL_ROUTES.CHANGE_PASSWORD,
            element: <CustomerChangePasswordPage />,
          },
        ],
      },
      { path: '*', element: <CustomerPortalNotFoundPage /> },
    ],
  },
  {
    path: '*',
    element: <CustomerPortalNotFoundPage />,
  },
]);
